import AncillaryCollectionUIModel from './ancillary-collection';
import ExtraBagsAncillaryMapUIModel from './extra-bags-ancillary-map';

class BaggageAncillaryOfferUIModel {
  constructor({
    _meta,
    adminFee = [],
    carryOn = [],
    extraBags = [],
    extraBagsLight = [],
    is20kInternationalBaggage,
    is25kInternationalBaggage,
    specialBags = [],
  }) {
    this.adminFee = new AncillaryCollectionUIModel(adminFee);
    this.carryOn = new AncillaryCollectionUIModel(carryOn);
    this.extraBags = new ExtraBagsAncillaryMapUIModel(extraBags);
    this.extraBagsLight = new ExtraBagsAncillaryMapUIModel(extraBagsLight);
    this.is20kInternationalBaggage = is20kInternationalBaggage;
    this.is25kInternationalBaggage = is25kInternationalBaggage;
    this.offerClass = _meta.class;
    this.specialBags = new AncillaryCollectionUIModel(specialBags);
  }

  /**
   * @return {Object}
   */
  getAllBags() {
    return this.extraBags.getAllAncillariesAsArray().concat(this.specialBags._ancillaries);
  }

  /**
   * Takes an array of paid ancillary models (bags). Figures out which one is the
   * heighest tier, and then gets you all the ancillaries that are above your
   * highest tier.
   * @return {ExtraBagsAncillaryMapUIModel}
   */
  getRemainingExtraBags(paidAncillaries) {
    const extraBagsTypes = paidAncillaries.map(anc => anc.type);
    let highestTier = 0;

    if (extraBagsTypes.size > 0 || extraBagsTypes.length > 0) {
      highestTier = this.getHighestTier(extraBagsTypes);
    }

    const allBags = this.extraBags.getAllAncillaries();
    const allTiers = Object.keys(allBags);
    const remainingTiers = allTiers.filter(tier => parseInt(tier, 10) > highestTier);
    const remainingExtraBags = {};

    remainingTiers.forEach(tier => {
      remainingExtraBags[tier] = allBags[tier];
    });

    return remainingExtraBags;
  }

  /**
   * Takes an array of ancillary types and tells you which one is the highest tier.
   * @return {number of tier - not the type of ancillary}
   */
  getHighestTier(extraBagsTypes) {
    const extraBagAncillaries = this.extraBags.getAllAncillaries();
    if (Object.keys(extraBagAncillaries).length > 0) {
      return Object.keys(extraBagAncillaries).reduce((acc, key) => {
        const extraBagAnc = extraBagAncillaries[key];
        const ancType = extraBagAnc.type;
        if (extraBagsTypes.indexOf(ancType) > 0 && acc < key ) {
          return key;
        } else {
          return acc;
        }
      });
    } else {
      return 0;
    }
  }

  /**
   * Return the first extra baggage object - used to get cms ancillary description
   * @return {AncillaryUIModel}
   */
  getSingleExtraBaggageAncillary() {
    const extraBagAncillaries = this.extraBags.getAllAncillaries();

    return Object.keys(extraBagAncillaries).length ?
      extraBagAncillaries[Object.keys(extraBagAncillaries)[0]] : null;
  }

  /**
   * Return the first extra baggage object - used to get cms ancillary description
   * @return {AncillaryUIModel}
   */
  getSingleAdminFee() {
    const adminFeeAncillaries = this.adminFee.getAllAncillaries();

    return Object.keys(adminFeeAncillaries).length ?
      adminFeeAncillaries[Object.keys(adminFeeAncillaries)[0]] : null;
  }

  getCarryOn() {
    const carryOnAncillaries = this.carryOn.getAllAncillaries();

    return Object.keys(carryOnAncillaries).length ?
      carryOnAncillaries[Object.keys(carryOnAncillaries)[0]] : null;
  }

  /**
   * @return {Object}
   */
  getExtraBags() {
    return this.extraBags.getAllAncillaries();
  }

  /**
   * @return {Array}
   */
  getExtraBagsAsArray() {
    return this.extraBags.getAllAncillariesAsArray();
  }

  getExtraBagsLightArray() {
    return this.extraBagsLight && this.extraBagsLight._ancillaries ? this.extraBagsLight.getAllAncillariesAsArray() : [];
  }

  /**
   * Return the total price of bags up to a specified tier
   * @param  {Number} tier - extra bag tier (from 0 - 7)
   * @return {Number}
   */
  getCumulativePriceByTier(tier) {
    return this.extraBags.getCumulativePriceByTier(tier);
  }

  getCumulativePriceByAdjustedTier(tier, extraBags, numFreeBags) {
    return this.extraBags.getCumulativePriceByTier(tier, extraBags, numFreeBags);
  }

  getAvailableBaggageOfferPrice(tier, numFreeBags, extraBags, extraBaggageTypeArray, counter) {
    let total = 0;
    let _tier = 0;
    let baggageStartIndex = numFreeBags;
    const currentBaggageCode = extraBaggageTypeArray[numFreeBags];
    const extraBagsKeys = Object.keys(extraBags);
    const firstOfferedBaggageCode = extraBags[extraBagsKeys[0]].type;
    const lastOfferedKey = parseInt(extraBagsKeys[extraBagsKeys.length - 1], 10);

    if (currentBaggageCode !== firstOfferedBaggageCode && numFreeBags !== parseInt(extraBagsKeys[0], 10)) {
      baggageStartIndex = parseInt(extraBagsKeys[0], 10);
      for (const index in extraBags) {
        let baggageNumber = parseInt(extraBags[index]._lanceJSON.commercialName[0], 10);
        if (!isNaN(parseInt(extraBags[index]._lanceJSON.commercialName[1], 10))) {
          baggageNumber = extraBags[index]._lanceJSON.commercialName[0] + extraBags[index]._lanceJSON.commercialName[1];
          baggageNumber = parseInt(baggageNumber, 10);
        }

        if (baggageNumber - numFreeBags === 1) {
          baggageStartIndex = parseInt(index, 10);
          tier = (baggageStartIndex - 1) + counter;
          break;
        }
      }
    }

    if (currentBaggageCode === firstOfferedBaggageCode) {
      baggageStartIndex = parseInt(extraBagsKeys[1], 10);
      if (tier < parseInt(extraBagsKeys[1], 10)) {
        tier += 1;
      } else if (tier === parseInt(extraBagsKeys[1], 10) && counter === 1) {
        _tier = tier;
        tier = _tier;
      } else if (tier >= parseInt(extraBagsKeys[1], 10) && counter > 1) {
        tier = (baggageStartIndex - 1) + counter;
      }
    }

    for (let i = baggageStartIndex; i <= lastOfferedKey; i++) {
      const keyNum = parseInt(i, 10);

      if (extraBags.hasOwnProperty(i) && keyNum <= tier) {
        const extraBag = extraBags[i];
        total += extraBag.currency.total;
      }
    }
    return { total, tier };
  }

  /**
   * @return {Array}
   */
  getSpecialBags() {
    return this.specialBags.getAllAncillaries();
  }

  getAdminFee() {
    return this.adminFee.getAllAncillaries();
  }

  /**
   * @param  {String} type - ancillary type
   * @return {AncillaryUIModel}
   */
  getSpecialBagByType(type) {
    return this.specialBags.getAncillaryByType(type);
  }

  /**
   * @return {Boolean}
   */
  getIs20kInternationalBaggage() {
    let flagIs20kInternationalBaggage = false;

    if (this.is20kInternationalBaggage) {
      flagIs20kInternationalBaggage = true;
    }

    return flagIs20kInternationalBaggage;
  }

  /**
   * @return {Boolean}
   */
  getIs25kInternationalBaggage() {
    let flagIs25kInternationalBaggage = false;

    if (this.is25kInternationalBaggage) {
      flagIs25kInternationalBaggage = true;
    }

    return flagIs25kInternationalBaggage;
  }
}

export default BaggageAncillaryOfferUIModel;
